import React from "react";
import { connect } from "react-redux";
import { Button, NumberBox, SelectBox } from "devextreme-react";
import TextField from "../../../../../Shared/fields/TextField";
import { setDataSelected, openCloseModalEliminarTrabajador } from "../actions";
import ModalEliminarTrabajador from "./modalEliminarTrabajador";
import LoadingOverlay from "../../../../../Shared/LoadingOverlay";
import validaciones from "../../../../../../helpers/validaciones";
import guid from "../../../../../../helpers/guid"

class AgregarTrabajadores extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      tipoDocumentos: [
        { Id: 1, Tipo: "Rut" },
        { Id: 2, Tipo: "Pasaporte" },
        { Id: 3, Tipo: "Otro" },
      ],
      isValidRut: null,
      ingresoMailTrabajador: [],
      ingresoRutTrabajador: [],
    };

    this.props.dispatch(setDataSelected({
      ...this.props.dataSelected,
      newWorkers: [],
    }));
  }

  handleAddWorker = () => {
    const { dataSelected } = this.props;
    dataSelected.newWorkers.push({
      Age: null,
      DocumentNumber: null,
      DocumentType: 1,
      Mail: null,
      Name: null,
      Phone: null,
    });
    dataSelected.isWorkersUpdate = true;
    this.props.dispatch(setDataSelected({
      ...dataSelected,
    }));
  }

  handleSubstractWorker = () => {
    const { dataSelected } = this.props;
    dataSelected.newWorkers.pop();
    dataSelected.isWorkersUpdate = true;
    this.props.dispatch(setDataSelected({
      ...dataSelected,
    }));
  }

  handleRemoveWorker = (event, i, e) => {
    const { onOpenModal } = this.props;
    onOpenModal(true, i);
  }

  handleChange = (item, i) => {
    const { dataSelected } = this.props;
    var arrayRut = [...this.state.ingresoRutTrabajador];
    let value = null;
    const newData = { ...dataSelected };
    const _split_id = item.element.id.split("_");
    const _element = _split_id[0];
    const _position = _split_id[1];

    if (_element === "DocumentType") {
      value = item.value;
    } else {
      value = item.event.target.value;
    }

    newData.isWorkersUpdate = true;
    switch (_element) {
      case "DocumentType": {
        newData.newWorkers[_position].DocumentType = item.value;
        if(item.value === 1 ){
          let tempRut = newData.newWorkers[_position].DocumentNumber
          if (tempRut && tempRut.length >= 8 && tempRut.length <= 12) {
            tempRut = validaciones.formatRut(tempRut, { showDots: true, showHyphen: true });
          }
          const isValid = validaciones.validateRut(tempRut);
          if (!isValid) {
            //const arrayRut = this.state.ingresoRutTrabajador;
            arrayRut.push(Number(_position));
            arrayRut = [...new Set(arrayRut)];  
            this.setState({
              ingresoRutTrabajador: arrayRut,
            });
          } else {
            arrayRut = arrayRut.filter((ee) => ee.toString() !== _position);
            this.setState({ ingresoRutTrabajador: arrayRut });
          }
          newData.newWorkers[_position].DocumentNumber = tempRut;
        }else{
          arrayRut = arrayRut.filter((ee) => ee.toString() !== _position);
          this.setState({ ingresoRutTrabajador: arrayRut });
          newData.newWorkers[_position].DocumentNumber = validaciones.cleanRut(newData.newWorkers[_position].DocumentNumber);
        }                
        break;
      }
      case "DocumentNumber": {
        if (newData.newWorkers[_position].DocumentType === 1) {
          const isValid = validaciones.validateRut(item.value);
          if (item.value && item.value.length >= 8 && item.value.length <= 12 && isValid) {
            item.value = validaciones.formatRut(item.value, { showDots: true, showHyphen: true });
            arrayRut = arrayRut.filter((ee) => ee.toString() !== _position);
            this.setState({ ingresoRutTrabajador: arrayRut });
          }else{
            if(item.value){                          
              arrayRut.push(Number(_position));
              arrayRut = [...new Set(arrayRut)];  
              this.setState({
                ingresoRutTrabajador: arrayRut,
              });
            }else{         
              this.setState({
                ingresoRutTrabajador: arrayRut ? arrayRut.filter(ee => ee !== Number(_position)) : [],
              });
            }
            
          }
        }
        newData.newWorkers[_position].DocumentNumber = item.value;
        break;
      }
      case "Name": {
        newData.newWorkers[_position].Name = value;
        break;
      }
      case "Age": {
        newData.newWorkers[_position].Age = value;
        break;
      }
      case "Phone": {
        newData.newWorkers[_position].Phone = value;
        break;
      }
      case "Mail": {
        const email = value;
        const isValid = validaciones.validarEmail(email);

        if (!isValid) {
          const arrayMail = this.state.ingresoMailTrabajador;
          arrayMail.push(Number(_position));
          this.setState({
            ingresoMailTrabajador: arrayMail,
          });
        } else {
          const arrayMail = this.state.ingresoMailTrabajador.filter((ee) => ee.toString() !== _position);
          this.setState({ ingresoMailTrabajador: arrayMail });
        }

        newData.newWorkers[_position].Mail = email;
        break;
      }
      default:
    }

    this.props.dispatch(setDataSelected(newData));
  };

  renderBoxTrabajadores = () => {
    const ingresoRutTrabajador = this.state.ingresoRutTrabajador;
    const ingresoMailTrabajador = this.state.ingresoMailTrabajador;
    const { dataSelected } = this.props;
    const card = (e,i) => {
      const rutValid = (e.DocumentNumber && ingresoRutTrabajador.find((element) => element === i) !== undefined) ? false : true
      const emailValid = e.Mail && ingresoMailTrabajador.find((element) => element === i) !== undefined ? false : true
      return (
      <div className="boxTrabajador" key={`e_${i}`}>

        <div className="row grid-table">
          <div className="grid-table-index">
            {i + 1}.
          </div>
          <div>
            <SelectBox
              id={`DocumentType_${i}`}
              value={e.DocumentType}
              dataSource={this.state.tipoDocumentos}
              onValueChanged={this.handleChange}
              displayExpr="Tipo"
              valueExpr="Id"
              searchEnabled
              style={{ height: 40 }}
            />
          </div>
          <div>
            <TextField
              key={guid.new()}
              id={`DocumentNumber_${i}`}
              value={e.DocumentNumber}
              maxLength={50}
              onValueChanged={this.handleChange}
              /*onKeyUp={(e) => {
                dataSelected.newWorkers[i].DocumentType === 1 ? e.event.target.value = e.event.target.value.replace(/[^0-9 K k]+/, "") : e.DocumentNumber = e.event.target.value;
              }}*/
              isValid={rutValid}
              validationError={{ message: "RUT Inválido" }}  
            />
          </div>
          <div>
            <TextField
              id={`Name_${i}`}
              onChange={this.handleChange}
              value={e.Name}
              maxLength={100}
              onKeyUp={(e) => {
                e.event.target.value = e.event.target.value.replace(/[^a-zA-Z ]+/, "");
              }}
              onKeyDown={(e) => {
                e.event.target.value = e.event.target.value.replace(/[^a-zA-Z ]+/, "");
              }}
              skipValidation
            />
          </div>
          <div>
            <TextField
              id={`Phone_${i}`}
              onChange={this.handleChange}
              maxLength={9}
              value={e.Phone}
              onKeyUp={(e) => {
                e.event.target.value = e.event.target.value.replace(/[^0-9]+/, "");
              }}
              onKeyDown={(e) => {
                e.event.target.value = e.event.target.value.replace(/[^0-9]+/, "");
              }}
              skipValidation
            />
          </div>
          <div>
            <TextField
              key={guid.new()}
              id={`Mail_${i}`}
              onValueChanged={this.handleChange}
              value={e.Mail}
              maxLength={60}
              skipValidation
              isValid={emailValid}
              validationError={{ message: "Email Inválido" }}  
            />
          </div>
          <div className="close-button">
            <Button
              icon="close"
              stylingMode="text"
              height={22}
              width={22}
              onClick={(event) => this.handleRemoveWorker(event, i, e)}
            />
          </div>
        </div>
      </div>
    )};
    return this.props.dataSelected.newWorkers && this.props.dataSelected.newWorkers.map(card);
  }

  render() {
    return (
      <React.Fragment>
        <ModalEliminarTrabajador />
        <div className="agendaSel">
          {this.props.isLoading && <LoadingOverlay />}
          <div className="col-12 ingresoTrabajadores">
            <div className="row">
              <div className="row-7 add-workers-title">¿Cuántos trabajadores vas a agregar?</div>
              <div className="col-3">
                <div className="dx-field-value contador" style={{ marginBottom: 20 }}>
                  <Button
                    className="more"
                    onClick={this.handleSubstractWorker}
                  >
                    -
                  </Button>
                  <NumberBox
                    min={0}
                    showSpinButtons={false}
                    readOnly
                    value={this.props.dataSelected.newWorkers && this.props.dataSelected.newWorkers.length}
                  />
                  <Button
                    className="less"
                    onClick={this.handleAddWorker}
                  >
                    +
                  </Button>
                </div>
              </div>
            </div>

            <div className="col-12 zero listaTabajadores">
              <div className="row zero headers-grid-table">
                <div></div>
                <div>
                  Tipo documento
                </div>
                <div>
                  N° Documento
                </div>
                <div>
                  Nombre
                </div>
                <div>
                  Celular
                </div>
                <div>
                  Email
                </div>
                <div>
                </div>
              </div>
              {this.renderBoxTrabajadores()}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.confirmacionSolicitudesAgendaSel.isLoading,
  dataSelected: state.confirmacionSolicitudesAgendaSel.dataSelected,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
  onOpenModal: (isOpen, worker) => dispatch(openCloseModalEliminarTrabajador(isOpen, worker)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AgregarTrabajadores);
